/* eslint-disable no-new */
import api from '../api.js';
import { SIDEMENU_CLASS, SIDEMENU_LIST_CLASS } from './sidemenu/constants';

api.Collapse.register(SIDEMENU_CLASS, SIDEMENU_LIST_CLASS);
